"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.getHarnesId = exports.getContract = void 0;
exports.loadCurrentInstallations = loadCurrentInstallations;
exports.setSelectedInstallation = setSelectedInstallation;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _companiesInTroubleApi = require("../../../../csc/api/companiesInTroubleApi");
var _SessionHandler = _interopRequireDefault(require("../../../../csc/utils/SessionHandler"));
var _Router = _interopRequireDefault(require("../../../../utils/Router"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Actions
var InstallationsActions = /*#__PURE__*/function (InstallationsActions) {
  InstallationsActions["LOAD_CURRENT_INSTALLATIONS"] = "api/reducer/GET_INSTALLATIONS";
  InstallationsActions["SET_SELECTED_INSTALLATIONS"] = "api/reducer/SET_SELECTED_INSTALLATIONS";
  return InstallationsActions;
}(InstallationsActions || {});
var initialState = {
  harnesId: '',
  contract: {},
  contractList: [],
  selectedContract: '',
  elemPos: ''
};
var getHarnesId = exports.getHarnesId = function getHarnesId(contract) {
  return contract === null || contract === void 0 ? void 0 : contract.harnesId;
};
var getContract = exports.getContract = function getContract(contracts, harnesId) {
  return contracts && contracts.find ? contracts.find(function (elem) {
    return getHarnesId(elem) === harnesId;
  }) : null;
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var getPreselectedContract = function getPreselectedContract(contracts) {
    var id = _Router.default.getParameter('harnesId');
    if (id && contracts) {
      return id;
    }
    if (contracts) {
      if (contracts[0]) {
        var hId = getHarnesId(contracts[0]) || null;
        _Router.default.setParameter({
          harnesId: hId,
          pos: 0
        });
        return hId;
      }
    }
    return null;
  };
  var getElemPosition = function getElemPosition(contracts, harnesId) {
    var id = _Router.default.getParameter('pos');
    if (id) {
      return id;
    }
    var pos = contracts === null || contracts === void 0 ? void 0 : contracts.indexOf(getContract(contracts, harnesId));
    _Router.default.setParameter({
      pos: pos
    });
    return pos;
  };
  switch (action.type) {
    case InstallationsActions.LOAD_CURRENT_INSTALLATIONS:
      return _objectSpread(_objectSpread({}, state), {}, {
        contractsList: action.data.innerData,
        harnesId: getPreselectedContract(action.data.innerData),
        contract: getContract(action.data.innerData, getPreselectedContract(action.data.innerData)),
        elemPos: getElemPosition(action.data.innerData, getPreselectedContract(action.data.innerData))
      });
    case InstallationsActions.SET_SELECTED_INSTALLATIONS:
      _Router.default.setParameter({
        harnesId: action.data.harnesId,
        pos: action.data.pos
      });
      _Router.default.setParameter({
        pos: action.data.pos
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        harnesId: action.data.harnesId,
        contract: action.data.contract,
        elemPos: action.data.pos
      });
    default:
      return state;
  }
}

// Action Creators
function loadCurrentInstallations(dispatch) {
  var resp = (0, _companiesInTroubleApi.getInstallations)();
  return resp.then(function (response) {
    dispatch({
      type: InstallationsActions.LOAD_CURRENT_INSTALLATIONS,
      data: {
        innerData: response.data ? response.data.content : {}
      }
    });
  });
}
function setSelectedInstallation(dispatch, harnesId, pos, contract) {
  _SessionHandler.default.resetPermissions();
  dispatch({
    type: InstallationsActions.SET_SELECTED_INSTALLATIONS,
    data: {
      harnesId: harnesId,
      pos: pos,
      contract: contract
    }
  });
}